const ROUTE_PERMISSIONS_MAP = {
  '/risk-management/risk-library': 4,
  '/risk-management/risk-register': 2,
  '/risk-management/action-tracker': 8,
  '/access-management/reviews': 14,
}

export default ROUTE_PERMISSIONS_MAP